import { Routes } from '@angular/router';

import { LayoutComponent } from '../layout/layout.component';
import { LoginComponent } from './page/login/login.component';
import { Error404Component } from './page/error404/error404.component';
import { Error500Component } from './page/error500/error500.component';

export const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full'
      },
      {
        path: 'login',
        component: LoginComponent
      },
      {
        path: 'home',
        loadChildren: () => import('./home/home.module').then(i => i.HomeModule)
      },
      {
        path: 'report',
        loadChildren: () => import('./report/report.module').then(i => i.ReportModule),
      }
    ]
  },
  // Not lazy-loaded routes
  {
    path: '404',
    component: Error404Component
  },
  {
    path: '500',
    component: Error500Component
  },
  // Not found
  {
    path: '**',
    redirectTo: 'login'
  }
];
